import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
const Blockly = GlobalImport.getBlockly();
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;

export class PhysicsSystemAttribute extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.PHYSICS, t.to('物理演算 環境設定', 'physic_system_setting'));
    this.setNameForCode('physics');
    this.setIsInToolbox(false);
  }
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setSceneColor(block);

    const gravity = new Blockly.FieldTextInput('-9.8');
    const friction = new Blockly.FieldTextInput('0.01');
    const restitution = new Blockly.FieldTextInput('0.3');
    const iterations = new Blockly.FieldTextInput('10');

    block
      .appendDummyInput()
      .appendField(t.to('重力', 'gravity'))
      .appendField(gravity, 'gravity')
      .appendField(t.to('摩擦', 'friction'))
      .appendField(friction, 'friction')
      .appendField(t.to('反発係数', 'restitution'))
      .appendField(restitution, 'restitution')
      .appendField(t.to('シミュレーター精度', 'iterations'))
      .appendField(iterations, 'iterations');

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const gravity = CodeSetting.getFieldValue(block, 'gravity');
    const friction = CodeSetting.getFieldValue(block, 'friction');
    const restitution = CodeSetting.getFieldValue(block, 'restitution');
    const iterations = CodeSetting.getFieldValue(block, 'iterations');

    const inner_attr = CodeSetting.buildAttribute(
      [
        [
          this.name_for_code,
          `gravity:${gravity};friction:${friction};restitution:${restitution};iterations:${iterations}`,
        ],
      ],
      attribute
    );
    return [inner_attr];
  }
}
